import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGroup = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={25} height={24} fill='none' {...props}>
    <g stroke='#089981' strokeLinecap='round' strokeLinejoin='round' strokeWidth={1.5}>
      <path d='M12.5 14h1c1.1 0 2-.9 2-2V2h-9C5 2 3.69 2.83 3.01 4.05' />
      <path d='M2.5 17c0 1.66 1.34 3 3 3h1c0-1.1.9-2 2-2s2 .9 2 2h4c0-1.1.9-2 2-2s2 .9 2 2h1c1.66 0 3-1.34 3-3v-3h-3c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1h1.29l-1.71-2.99A2.02 2.02 0 0 0 17.34 5H15.5v7c0 1.1-.9 2-2 2h-1' />
      <path d='M8.5 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4M16.5 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4M22.5 12v2h-3c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1h1.29zM2.5 8h6M2.5 11h4M2.5 14h2' />
    </g>
  </svg>
);
export default SvgGroup;
